/*
 * Copyright (c) 2020. World Wide Generation Ltd
 */


import { API } from '../../constants/errors';

export default class ApiError extends Error {
  public readonly safe = true;
  constructor(m: string = API.GENERIC, public status = 500) {
    super(m);
    Object.setPrototypeOf(this, ApiError.prototype);
  }
}
